import React from 'react';
import { useSelector } from 'react-redux';
import { useGetToDosQuery } from '../features/api/apiSlice';
import Todo from './Todo';

const TodoList = () => {
  const { data: todos, isLoading, isError } = useGetToDosQuery();

  const filters = useSelector((state) => state.filters);
  const { status, color } = filters;
  let content = null;
  if (isLoading) {
    content = (
      <>
        <p>Loading...</p>
      </>
    );
  }
  if (!isLoading && isError) {
    content = <p>There was an error occurred</p>;
  }
  if (!isLoading && !isError && todos?.length < 0) {
    content = <p>No Todos Found!</p>;
  }
  if (!isLoading && !isError && todos?.length > 0) {
    content = todos
      .filter((todo) => {
        const { status } = filters;
        switch (status) {
          case 'Complete':
            return todo.completed;
          case 'Incomplete':
            return !todo.completed;

          default:
            return true;
        }
      })
      .filter((todo) => {
        const { colors } = filters;
        if (colors.length > 0) {
          return colors.includes(todo?.color);
        }
        return true;
      })
      .map((todo) => <Todo key={todo.id} todo={todo} />);
  }

  return (
    <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
      {content}
    </div>
  );
};

export default TodoList;
